import { Button, TextField } from '@mgh-app/component-library';
import { ValidationErrors } from 'components/ValidationErrors';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ResetPasswordError, useLazyResetPasswordQuery } from 'services/UsersService';
import { display, flexDirection, margin, twCls } from 'style';
import { EmailUtils } from 'utils/EmailUtils';

interface Fields {
  email: string;
}

type ErrorTypes = 'required' | 'pattern';

const ErrorHelper = {
  email: {
    required: 'Email Address is required',
    pattern: 'Email Address is incorrect',
  },
};

export const ForgottenPassword = (): JSX.Element => {
  const { setTitle, showNavigationButtons, showUserProfile, navigateHomeAction, showHomeButton } =
    useContext(MainLayoutContext);
  const { handleSubmit, control } = useForm<Fields>({
    defaultValues: {
      email: '',
    },
  });
  const [customError, setCustomError] = useState<string[]>();
  const [resetPassword] = useLazyResetPasswordQuery();
  const { navigateSetPassword } = useAppNavigation();

  const sendVerificationCode = async ({ email }: Fields) => {
    setCustomError([]);
    try {
      await resetPassword({ email }).unwrap();
      navigateSetPassword(email);
    } catch (err) {
      const error = err as ResetPasswordError;
      if (error.message) {
        if (Array.isArray(error?.message)) {
          setCustomError(error.message);
        } else if (error?.message) {
          setCustomError([error.message]);
        } else {
          setCustomError(['Unknown error']);
        }
      } else {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    setTitle('Forgotten Password');
    showNavigationButtons(true);
    showUserProfile(false);
    showHomeButton(false);
  }, [navigateHomeAction, setTitle, showHomeButton, showNavigationButtons, showUserProfile]);

  return (
    <div className={twCls(display('flex'), flexDirection('flex-col'), margin('mt-20'))}>
      <p>Enter the email address of your account and we will send you a verification code.</p>
      <Controller
        name="email"
        control={control}
        rules={{
          required: true,
          pattern: EmailUtils.EmailRegex,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            error={error !== undefined}
            helperText={ErrorHelper.email[error?.type as ErrorTypes]}
            className={twCls(margin('mt-11'))}
            label="Email Address"
            {...field}
          />
        )}
      />
      <ValidationErrors className={twCls(margin('mt-10'))} errors={customError} />
      <Button className={twCls(margin('mt-4'))} onClick={handleSubmit(sendVerificationCode)}>
        Continue
      </Button>
    </div>
  );
};
